import { REPORTS_DEFAULT_FILTERS } from '@constants/Reports/reportsDefaultToolbar.constants'
import { ReportsKpiMetric } from '@dataTypes/reports.type'

export const REFERRAL_REPUTATION_FILTERS = REPORTS_DEFAULT_FILTERS

export const REFERRAL_REPUTATION_KPI_METRICS: ReportsKpiMetric[] = [
  {
    id: 'patient-referrals-made',
    title: 'Patient Referrals Made',
    value: '112',
    footer: '+9',
    tone: 'positive',
  },
  {
    id: 'revenue-referred',
    title: 'Revenue from Referred Patients',
    value: '$86K',
    footer: '+$6K',
    tone: 'positive',
  },
  {
    id: 'nps-average',
    title: 'NPS (Average)',
    value: '54',
    footer: '+3',
    tone: 'positive',
  },
  {
    id: 'feedback-response-rate',
    title: 'Feedback Response Rate',
    value: '18',
    unitInline: '%',
    footer: '+2 pts',
    tone: 'positive',
  },
]

/** Referrals logged in CRM by month. */
export const REFERRAL_MONTHLY_MADE_DATA = [
  { month: 'Jul', referrals: 14 },
  { month: 'Aug', referrals: 17 },
  { month: 'Sep', referrals: 19 },
  { month: 'Oct', referrals: 22 },
  { month: 'Nov', referrals: 20 },
  { month: 'Dec', referrals: 25 },
]

/** Unscheduled treatment value buckets (same structure as treatment funnel). */
export const REFERRAL_VALUE_BUCKET_ROWS = [
  { id: 'b1', label: '$0-$500', count: 60, feesK: 56 },
  { id: 'b2', label: '$500-$1.5K', count: 50, feesK: 14.4 },
  { id: 'b3', label: '$1.5K-$3K', count: 40, feesK: 54 },
  { id: 'b4', label: '$3K+', count: 30, feesK: 47.6 },
]

export type NpsFeedbackTrendRow = {
  month: string
  nps: number
  responses: number
}

export const NPS_FEEDBACK_TREND_MONTHLY: NpsFeedbackTrendRow[] = [
  { month: 'Jul', nps: 42, responses: 180 },
  { month: 'Aug', nps: 45, responses: 195 },
  { month: 'Sep', nps: 48, responses: 210 },
  { month: 'Oct', nps: 50, responses: 220 },
  { month: 'Nov', nps: 52, responses: 230 },
  { month: 'Dec', nps: 54, responses: 238 },
]

export type FeedbackChannelRow = {
  id: string
  channel: string
  responses: number
  sharePct: number
  avgRating: number
}

export const FEEDBACK_CHANNEL_ROWS: FeedbackChannelRow[] = [
  {
    id: 'sms',
    channel: 'SMS Survey',
    responses: 124,
    sharePct: 52,
    avgRating: 4.6,
  },
  {
    id: 'email',
    channel: 'Email Survey',
    responses: 62,
    sharePct: 26,
    avgRating: 4.5,
  },
  {
    id: 'google',
    channel: 'Google Reviews',
    responses: 38,
    sharePct: 16,
    avgRating: 4.7,
  },
  {
    id: 'others',
    channel: 'Others',
    responses: 14,
    sharePct: 6,
    avgRating: 4.4,
  },
]
